import { Helmet } from 'react-helmet';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryData, usePostMessage } from 'spectacle-ui-game-bridge-react';
import { getPath } from '../../config';
import Build from '../../components/build/build';
import Debug from '../../components/debug/debug';
import ErrorModal from '../../components/errorModal/errorModal';
import LoadingIndicator from '../../components/loadingIndicator/loadingIndicator';
import useBodyBackground from '../../hooks/useBodyBackground';
import useCDNI from '../../hooks/useCDNI';
import useContentForBuild from '../../hooks/useContentForBuild';
import AgePicker from '../../components/agePicker/agePicker';
import './acceptance.sass';

const TWO_HOURS = 7200;

export default function AgeGate() {
  const navigate = useNavigate();
  const [age, setAge] = useState(0);
  const [systemCountry] = useQueryData<string>('game', 'systemCountry');
  const [UKAgeGatedTimestamp] = useQueryData<string>('webviewdata', 'UKAgeGatedTimestamp');
  const setUKAgeGatedTimestamp = usePostMessage('setUKAgeGatedTimestamp');
  const [content, loading, errorContent] = useContentForBuild();
  const isUKRegion = systemCountry === 'UK';
  const { error } = useCDNI(content);

  useBodyBackground(`url(${getPath('bg_general')}) no-repeat top center fixed #000`);

  const checkAge = () => {
    setUKAgeGatedTimestamp();

    if (age >= 18) {
      navigate('/acceptance');
    } else {
      navigate('/gated');
    }
  };

  useEffect(() => {
    const now = Date.now() / 1000;

    // Time has not Elapsed, show error state
    if (Number(UKAgeGatedTimestamp) + TWO_HOURS >= now) {
      navigate('/gated');
    }
  }, [UKAgeGatedTimestamp, navigate]);

  return (
    <>
      <Helmet>
        <title>{content?.reviewTerms}</title>
      </Helmet>
      {loading && (
        <div className="loading-mask">
          <LoadingIndicator />
        </div>
      )}
      {content && (
        <div className="centered">
          <div className="acceptance">
            <div className="logo-inline">
              <img src={getPath('menu_cod_logo_lg')} alt="Call of Duty" />
              <h1>{content.tellUsYourAge}</h1>
            </div>
            <div>
              <AgePicker onChange={setAge} count={99} label={content.selectAge} />
            </div>
            <button disabled={age === 0} className="cta cta--wide" onClick={checkAge}>
              {content.continue}
            </button>
          </div>
        </div>
      )}
      <div className="build">
        <Build />
      </div>
      <ErrorModal error={error} />
      <Debug
        enabled={!!content?.showDeveloperOverlay}
        vars={{
          errorContent,
          systemCountry,
          isUKRegion,
          UKAgeGatedTimestamp,
        }}
      >
        <button onClick={() => window.location.reload()}>reload</button>
      </Debug>
    </>
  );
}
